'use client';

import { useEffect, useState } from 'react';

export default function SignInMessage() {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const response = await fetch('/api/signin-message');
        const data = (await response.json()) as { message: string };
        setMessage(data.message);
      } catch {
        // ignore
      }
    };

    void load();
  }, []);

  return (
    <div className="bg-secondary-75 basis-5/12 h-full font-bold text-6xl hidden md:flex justify-center items-center text-center">
      {message && <span dangerouslySetInnerHTML={{ __html: message }} />}
    </div>
  );
}
